import * as React from "react"
import {Alert} from "react-bootstrap";
import {useCallOutQuery} from "../../../../../hooks/useCallOutQuery";

export const CallOut = () => {
    const {callOut} = useCallOutQuery();

    if (!callOut) return <></>;

    return (
        <Alert variant="warning" className="d-flex align-items-center mt-3">
          {callOut}
        </Alert>
    )
}